import React from 'react';
import PropTypes from 'prop-types';

import ArrowUpIcon from '@tradera/blueprint/theme/icons2/arrow-up.svg?jsx';
import ArrowDownIcon from '@tradera/blueprint/theme/icons2/arrow-down.svg?jsx';

class ExpandableMenuItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: this.props.defaultExpanded
        };
    }

    toggleOpen = () => {
        this.setState(
            (prevState) => ({
                expanded: !prevState.expanded
            }),
            () => {
                const { onOpen = () => {}, onClose = () => {} } = this.props;
                if (this.state.expanded) {
                    onOpen();
                } else {
                    onClose();
                }
            }
        );
    };

    componentDidUpdate(prevProps) {
        if (prevProps.defaultExpanded !== this.props.defaultExpanded) {
            this.setState({ expanded: prevProps.defaultExpanded });
        }
    }

    render() {
        const {
            imageUrl,
            icon,
            label,
            className,
            imageContainerClassName,
            border,
            children,
            href
        } = this.props;
        const { expanded } = this.state;

        return (
            <li
                className={`site-dropdown__item-expandable ${
                    border ? 'border-bottom' : ''
                } ${expanded ? 'site-dropdown__item-expanded' : ''}
            `}>
                <a
                    href={href || '#'}
                    onClick={(e) => {
                        if (children) {
                            e.preventDefault();
                            this.toggleOpen();
                        }
                    }}
                    aria-expanded={expanded.toString()}
                    className={`site-dropdown__transparent-a p-0 m-0 d-flex flex-row align-items-center site-dropdown__item ${
                        className ? className : ''
                    }`}>
                    {icon && (
                        <span
                            className={`site-dropdown__item__image d-flex align-items-center justify-content-center ${
                                imageContainerClassName
                                    ? imageContainerClassName
                                    : ''
                            }`}
                            style={{ backgroundImage: imageUrl }}>
                            {icon}
                        </span>
                    )}
                    <span className="text-left flex-grow">{label}</span>
                    <span className="ml-auto d-flex pr-2">
                        {expanded ? (
                            <ArrowUpIcon className="icon" />
                        ) : (
                            <ArrowDownIcon className="icon" />
                        )}
                    </span>
                </a>
                {expanded && <ul className="plain-list">{children}</ul>}
            </li>
        );
    }
}

ExpandableMenuItem.defaultProps = {
    defaultExpanded: false,
    border: true
};

ExpandableMenuItem.propTypes = {
    imageUrl: PropTypes.string,
    icon: PropTypes.node,
    label: PropTypes.node,
    className: PropTypes.string,
    imageContainerClassName: PropTypes.string,
    border: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func
};

export default ExpandableMenuItem;
